// React import not needed in modern React

export const AnimatedToggle = ({ 
  checked = false, 
  onChange, 
  disabled = false,
  size = 'md',
  title,
  className = ''
}) => {
  const sizeClass = size === 'sm' ? 'toggle-sm' : size === 'lg' ? 'toggle-lg' : '';

  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      title={title}
      className={`
        toggle
        ${sizeClass}
        ${checked ? 'toggle-success' : '[--tglbg:theme(colors.base-300)]'}
        ${disabled ? 'opacity-50' : ''}
        ${className}
      `}
    />
  );
};